"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeRatioMap = exports.sizeRatioDetails = void 0;
var sizeRatioDetails = {
  small: {
    width: 16,
    height: 9
  },
  medium: {
    width: 4,
    height: 3
  },
  large: {
    width: 6,
    height: 5
  },
  xLarge: {
    width: 1,
    height: 1
  },
  answer: {
    width: 4,
    height: 3
  }
};
exports.sizeRatioDetails = sizeRatioDetails;
var sizeRatioMap = {
  // 16 / 9
  small: sizeRatioDetails.small.width / sizeRatioDetails.small.height,
  // 4 / 3
  medium: sizeRatioDetails.medium.width / sizeRatioDetails.medium.height,
  // 6 / 5,
  large: sizeRatioDetails.large.width / sizeRatioDetails.large.height,
  // 1 / 1
  xLarge: sizeRatioDetails.xLarge.width / sizeRatioDetails.xLarge.height,
  // 4 / 3
  answer: sizeRatioDetails.answer.width / sizeRatioDetails.answer.height
};
exports.sizeRatioMap = sizeRatioMap;